import { getTokenTransactionsApiV1BillingOrgIdBillingTransactionsGet } from '@/common/api/client/sdk.gen'
import type { GetTokenTransactionsApiV1BillingOrgIdBillingTransactionsGetResponse } from '@/common/api/client/types.gen'
import { useCurrentOrg } from '@/app/entities/org/model'
import { usePagination } from '@/common/hooks/usePagination'
import { useQuery } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

export const useTransactions = () => {
    const { data: currentOrg } = useCurrentOrg()
    const { currentPage, pageSize, setCurrentPage } = usePagination()

    const { data, isLoading, error } = useQuery<
        GetTokenTransactionsApiV1BillingOrgIdBillingTransactionsGetResponse,
        AxiosError
    >({
        queryKey: ['transactions', currentPage, pageSize, currentOrg?.id],
        queryFn: async () => {
            if (!currentOrg?.id) return Promise.reject(new Error('Missing organization id'))
            return getTokenTransactionsApiV1BillingOrgIdBillingTransactionsGet({
                path: { org_id: currentOrg.id },
                query: { page: currentPage, size: pageSize },
            }).then(r => r.data!)
        },
        enabled: !!currentOrg?.id,
    })

    return { data, isLoading, error, currentPage, setCurrentPage, totalPages: data?.pages }
}
